/**
 *
 * CourseListItem
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import moment from 'moment';

// antd component
import { List, Tooltip } from 'antd';

// icons
import { WarningOutlined } from '@ant-design/icons';

function CourseListItem({
  element,
  searchString,
  activeEl,
  active,
  // formats
  timeFormat,
  dateFormat,
  // func
  customHighlighter,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('course-list-meta', className);

  let responsible = element?.responsible?.description
      ? `${element?.responsible?.description?.lastname} ${element?.responsible?.description?.firstname}`
      : '';
    
  const courseTime = `${moment(element?.course_time_start).format('H:mm')} - ${moment(element?.course_time_end).format('H:mm')}`;
  const courseWeek = element?.course_week + `${courseTime ? ', ' : ''}`;
  const length = `${element?.students?.length} étudiants`;

  return element && (
    <List.Item.Meta
      className={childClassNames}
      style={{ borderLeft: `6px solid ${element?.subject?.color}` }}
      title={
        <>
          <span className="title">{customHighlighter(element?.subject?.name, searchString)}</span>
          <span className="class-title">
            {element?.class_info?.title ? (
              customHighlighter(element?.class_info?.title, searchString)
            ) : (
              <Tooltip
                title="Mettez la classe!"
                className="tooltip-std"
                key={'info-' + element?._id}
              >
                <WarningOutlined />
              </Tooltip>
            )}
          </span>
        </>
      }
      description={
        <>
          <span className="course-time">
            {customHighlighter(courseWeek, searchString)}
            {customHighlighter(courseTime, searchString)}
          </span>
          <span className="students-amount">
            {customHighlighter(length, searchString)}
          </span>
          {customHighlighter(responsible, searchString)}
          <span className="course-name">
            {customHighlighter(element?.course_code, searchString)}
          </span>
        </>
      }
    />
  );

};

CourseListItem.defaultProps = {
  dateFormat: 'DD.MM.YYYY',
  timeFormat: 'HH:mm',
};
CourseListItem.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
  searchString: PropTypes.string,
  customHighlighter: PropTypes.func,
};

export default memo(CourseListItem);